import { render, staticRenderFns } from "./gamearea.vue?vue&type=template&id=013b8dda&scoped=true&"
import script from "./gamearea.vue?vue&type=script&lang=ts&"
export * from "./gamearea.vue?vue&type=script&lang=ts&"
import style0 from "./gamearea.vue?vue&type=style&index=0&id=013b8dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b8dda",
  null
  
)

export default component.exports